import {Calendar} from 'lucide-react';
import {useAuth} from "@/provider/AuthProvider";
import {myAcademy} from "@/lib/services/academyService";

import { Card } from "antd";
import {
    CalendarOutlined,
    ClockCircleOutlined,
    StarOutlined,
} from "@ant-design/icons";
import WelcomeDashboardBox from "@/components/welcomeDashboard/WelcomeDashboardBox";

export default function AdminWelcomeSection() {
   return <WelcomeDashboardBox mode={'admin'} />
}
